// src/utils/logEvent.js
import api from './api'; // Use your shared Axios instance

export const logGuestSession = async (visitorId, sessionId, name, reason) => {
  try {
    await api.post('/api/guest-session/', {
      visitor_id: visitorId,
      session_id: sessionId,
      name,
      reason,
    });
  } catch (err) {
    console.error('Failed to log guest session', err);
  }
};

export const logOnboardingEvent = async (eventType, eventData = {}) => {
    try {
      // Generate or retrieve session ID
      let sessionId = localStorage.getItem("session_id");
      if (!sessionId) {
        sessionId = crypto.randomUUID();
        localStorage.setItem("session_id", sessionId);
      }
  
      // Send POST request to your Django API
      await api.post('/api/onboarding-events/', {
        session_id:   sessionId,
        event_type:   eventType,
        event_data:   eventData,
      });
    } catch (error) {
      console.error('Failed to log onboarding event', error);
    }
  };
  
  